import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: 12px 16px;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #fff;
    outline: none;
    transition: all 0.3s ease;
    font-family: inherit;

    &:focus {
      border-color: ${({ theme }) => theme.primary || '#2563eb'};
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: rgba(255, 255, 255, 0.02);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }

  .loading-indicator {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    
    small {
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
      font-style: italic;
    }
  }

  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;

    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }

    .suggestion-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 12px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      cursor: pointer;
      transition: background 0.2s;
      background: transparent !important;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.05) !important;
      }

      .suggestion-icon {
        font-size: 18px;
        line-height: 1;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .suggestion-content {
        flex: 1;
        min-width: 0;

        .suggestion-main {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #000000 !important;
          margin-bottom: 4px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .suggestion-secondary {
          font-size: 12px !important;
          color: #666666 !important;
          line-height: 1.4 !important;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    /* Additional text color enforcement for all nested elements */
    * {
      color: inherit;
    }

    .suggestion-item * {
      background: transparent;
    }

    div[class*="suggestion"] {
      color: #000000 !important;
    }
    }
  }
`;

export default Container;
